import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.343 7.343a8 8 0 1 1 11.314 11.314z","key":"svg-0"}],["path",{"d":"M10.828 13.34l-4.242 4.243a2 2 0 1 0 2.828 2.828","key":"svg-1"}]]

const IconUmbrella2 = createReactComponent('outline', 'umbrella-2', 'Umbrella2', __iconNode);

export default IconUmbrella2;